import { render, staticRenderFns } from "./recDetail.vue?vue&type=template&id=2cab4846&scoped=true"
import script from "./recDetail.vue?vue&type=script&lang=js"
export * from "./recDetail.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/recDetail.css?vue&type=style&index=0&id=2cab4846&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cab4846",
  null
  
)

export default component.exports